import React from 'react';
import { Container } from 'react-bootstrap';
import SectionHeading from './SectionHeading';
import { BsEnvelopeAtFill, BsGithub, BsLinkedin } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Contact = () => {
    return (
        <div className='section-padding-top section-padding-bottom'>
            <Container>
                <SectionHeading heading={'Contact'} />
                <div className='contactSection'>
                    <div className='contactLink'>
                        <div className='contactIcon'>
                            <BsLinkedin />
                        </div>
                        <Link to='https://www.linkedin.com/in/kavitakanwar/'>kavitakanwar</Link>
                    </div>
                    <div className='contactLink'>
                        <div className='contactIcon'>
                            <BsGithub />
                        </div>
                        <Link to='https://github.com/Kavii1'>Kavii1</Link>
                    </div>
                    <div className='contactLink'>
                        <div className='contactIcon'>
                            <BsEnvelopeAtFill />
                        </div>
                        <a href='mailto:kavitasisodiya1999@gmail.com'>
                            kavitasisodiya1999@gmail.com
                        </a>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Contact;
